/* Component Dependencies */
var aboutTheHotelDescriptionTemplate = require('templates/aboutTheHotelDescription.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'aboutTheHotelDescription',
  template: {
    'aboutTheHotelDescription': aboutTheHotelDescriptionTemplate
  },
  events: {
    'click .js-show-more-toggle': 'toggleDescription'
  },
  bindEvents: function($) {
    var _self = this;

    $(window).on('load resize', function() {
        _self.handleDescriptionBlockDisplay();
    });
  },
  /**
   * This function is used to restrict the display of description block to maximum 5 lines
   */
  handleDescriptionBlockDisplay: function() {
      var descriptionContainer,
          showMoreButton,
          maxHeight;

      descriptionContainer = this.$el.find('.l-description');
      showMoreButton = this.$el.find('.js-show-more-toggle');
      maxHeight = parseInt(descriptionContainer.css('line-height')) * 5;
      showMoreButton.addClass('l-display-none');
      if (showMoreButton.data('is-more') === true) {
          descriptionContainer.removeClass('l-overflow-hidden t-collapsed-height');
          if (descriptionContainer.height() > maxHeight) {
              descriptionContainer.addClass('l-overflow-hidden t-collapsed-height');
          }
      }
      if (descriptionContainer.height() > maxHeight) {
          showMoreButton.removeClass('l-display-none');
      }
      descriptionContainer.addClass('l-margin-none');
  },
  /**
   * This function is used to toggle the Description text on the click of showMore/showLess button
   * @param {Object} event Mouse event triggered on showMore/showLess click
   */
  toggleDescription: function(event) {
    event.preventDefault();
    var showMoreButton = $(event.currentTarget),
        descriptionContainer = this.$el.find('.l-description');

    showMoreButton.data('is-more') ? showMoreButton.data('is-more', false).text(showMoreButton.data('show-less-label')) : showMoreButton.data('is-more', true).text(showMoreButton.data('show-more-label'));
    showMoreButton.toggleClass('t-icon-plus t-icon-minus');
    descriptionContainer.toggleClass('t-collapsed-height l-overflow-hidden');
  }
});
